export default __webpack_public_path__ + "static/media/alternative-solar-logo.7766e69b.png";